// libs
import * as React from 'react'

// interfaces / constants

// classes / components
import Notification, {
  clsHighlightedText,
  clsText,
  NotificationProps
} from 'src/components/notifications/notification'

// helpers
import { textResources } from 'src/lang/de'
import DateFormatter from 'src/utils/date_formatter/date_formatter'

// images
import * as overlayInactive from 'src/components/notifications/badges/group@2x.png'
import * as overlayActive from 'src/components/notifications/badges/group_active@2x.png'

const labels = textResources.notification

export type GroupNotificationProps = {
  contentItemTitle: string | null | undefined;
  createdAt: string;
  groupName: string;
} & Pick<
  NotificationProps,
  'avatarImage' | 'initiatorName' | 'isRead' | 'onClick'
>;

const GroupNotification: React.FC<GroupNotificationProps> = ({
  avatarImage,
  contentItemTitle,
  createdAt,
  groupName,
  initiatorName,
  isRead,
  onClick
}) => {
  return (
    <Notification
      avatarImage={avatarImage}
      badgeImageNotRead={overlayActive}
      badgeImageRead={overlayInactive}
      footer={DateFormatter.asTimeAgo(createdAt)}
      initiatorName={initiatorName}
      isRead={isRead}
      onClick={onClick}
    >
      <span className={clsText}>{' ' + labels.notificationGroupPostStart}</span>
      <strong className={clsHighlightedText}>{`„${groupName}“`}</strong>
      <span className={clsText}>{labels.notificationGroupPostEnd}</span>
      {contentItemTitle && (
        <strong
          className={clsHighlightedText}
        >{`„${contentItemTitle}“`}</strong>
      )}
    </Notification>
  )
}

export default GroupNotification
